import React from "react";
import { cn } from "@/lib/utils";

// status: pending, approved, credit_checked, dispatched, loading, in_transit, delivered, cancelled
const MAP = {
  pending: { label: "Pending", color: "bg-status-pending", text: "text-status-pending" },
  approved: { label: "Approved", color: "bg-chart-2", text: "text-chart-2" },
  credit_checked: { label: "Credit OK", color: "bg-chart-2", text: "text-chart-2" },
  dispatched: { label: "Dispatched", color: "bg-status-transit", text: "text-status-transit" },
  loading: { label: "Loading", color: "bg-primary", text: "text-primary" },
  in_transit: { label: "In Transit", color: "bg-status-transit", text: "text-status-transit" },
  delivered: { label: "Delivered", color: "bg-status-delivered", text: "text-status-delivered" },
  cancelled: { label: "Cancelled", color: "bg-status-cancelled", text: "text-status-cancelled" },
  available: { label: "Available", color: "bg-status-delivered", text: "text-status-delivered" },
  assigned: { label: "Assigned", color: "bg-status-transit", text: "text-status-transit" },
  on_trip: { label: "On Trip", color: "bg-status-transit", text: "text-status-transit" },
  off_duty: { label: "Off Duty", color: "bg-muted-foreground", text: "text-muted-foreground" },
  maintenance: { label: "Maintenance", color: "bg-status-pending", text: "text-status-pending" },
  paid: { label: "Paid", color: "bg-status-delivered", text: "text-status-delivered" },
  unpaid: { label: "Unpaid", color: "bg-status-cancelled", text: "text-status-cancelled" },
  partial: { label: "Partial", color: "bg-status-pending", text: "text-status-pending" },
  verified: { label: "Verified", color: "bg-status-delivered", text: "text-status-delivered" },
  rejected: { label: "Rejected", color: "bg-status-cancelled", text: "text-status-cancelled" },
};

export default function StatusBadge({ status, className }) {
  const s = MAP[status] || { label: status, color: "bg-muted-foreground", text: "text-muted-foreground" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-border/60 bg-background px-2.5 py-0.5 text-xs font-medium",
        s.text,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", s.color)} />
      {s.label}
    </span>
  );
}
